export default __webpack_public_path__ + "static/media/Terri Stolpa.c9bd364a.png";